module.exports = __webpack_public_path__ + "9571498c3918f41d8aa02139b595d446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/piano-button-pressed-background.png
// module id = 47
// module chunks = 0